module.exports = __webpack_public_path__ + "img/swarn.179f2b4d.svg";